<div class="tw:w-full tw:px-[15px] tw:mx-auto" style="min-height: calc(100vh - 480px);">
  <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">

    <ng-template #utilityBarForm>

      <!-- tw:px-3 = 12px, matching the main content card's side margins (tw:mx-3);
           rows below carry no extra horizontal insets of their own. -->
      <div class="tw:pt-4 tw:pb-4 tw:px-3">

        <!-- Switch on, one responsive .filter-bar serves every width and the mobile variant is not rendered. -->
        <div [class.desktop-grid]="!filtersEnabled" [class.filter-bar]="filtersEnabled">

          <div class="tw:flex tw:flex-wrap filter-bar__group">

            <div class="tw:w-1/2 tw:flex tw:flex-col tw:p-0 filter-bar__field">
              <label class="field__label">{{ filtersEnabled ? 'Client' : '--- Select Client ---' }}</label>
              <app-searchable-select class="tw:w-full" [(ngModel)]="selectedClient" (ngModelChange)="onClientChanged($event)" [items]="clientList"
                displayField="dropdownDisplay" [disabledPredicate]="clientDisabled"
                placeholder="--- Select Client ---" searchPlaceholder="Search clients…"></app-searchable-select>
              @if (initialSearchClicked && !searchAllClients && (selectedClient === null || selectedClient === undefined)) {
                <div class="tw:text-danger">
                  Please select a client.
                </div>
              }
            </div>

            <ng-container *appFeatureSwitch="filtersKey">
              <div class="tw:flex-1 tw:flex tw:flex-col tw:justify-end tw:px-2 filter-bar__group">
                <app-brand-filter class="filter-bar__field" [(companyIds)]="companyIds"></app-brand-filter>
              </div>

              <div class="tw:flex-1 tw:flex tw:flex-col tw:justify-end tw:px-2 filter-bar__field" data-filter="survey-type">
                <label class="field__label">Survey type</label>
                <select class="field__control" [(ngModel)]="surveyType">
                  <option value="">Any</option>
                  <option value="SESSION">Session</option>
                  <option value="TUITION">Tuition</option>
                </select>
              </div>

              <div class="tw:flex-1 tw:flex tw:flex-col tw:justify-end tw:px-2 filter-bar__field" data-filter="tutor">
                <label class="field__label">Tutor</label>
                <app-searchable-select class="tw:w-full" [(ngModel)]="tutorId" [items]="tutorList"
                  displayField="name" valueField="id" [disabled]="searchAllClients || !selectedClient"
                  placeholder="All tutors" searchPlaceholder="Search tutors…"></app-searchable-select>
              </div>
            </ng-container>

            <div class="tw:flex-1 tw:flex tw:justify-center tw:items-end tw:pb-2 tw:px-2 filter-bar__field filter-bar__field--check">
              <label class="field__toggle"><input type="checkbox" [(ngModel)]="searchAllClients" /><span class="field__toggle-track"></span><span class="overview-filter-label">Search All Clients</span></label>
            </div>

            @if (filtersEnabled) {
              @if (selectedFilterDateRange == 'custom') {
                <div class="filter-bar__field">
                  <label class="field__label">From Date</label>
                  <input type="date" class="field__control" [(ngModel)]="fromDate" [ngModelOptions]="{standalone: true}" (change)="validateDates()">
                  @if (fromDateAfterToDate) {
                    <span class="field__error">From date cannot be after To date</span>
                  }
                </div>
                <div class="filter-bar__field">
                  <label class="field__label">To Date</label>
                  <input type="date" class="field__control" [(ngModel)]="toDate" [ngModelOptions]="{standalone: true}" (change)="validateDates()">
                </div>
              }
            } @else {
              <div class="tw:flex-1 tw:flex tw:items-end tw:p-0">
                <button type="button" class="btn btn-primary tw:w-full" style="height: 38px;"
                (click)="getFeedbackData()" [disabled]="fromDateAfterToDate">Search</button>
              </div>
            }

          </div>

          @if (!filtersEnabled) {
          <!-- Tailwind-only classes here: the global (unlayered) .flex-row sets display:flex, which
               beats the layered tw:hidden/tw:lg:hidden utilities and made both variants render. -->
          <div class="tw:hidden tw:lg:flex tw:flex-row tw:flex-wrap tw:w-full tw:justify-between">

            <!-- inline padding: the unlayered .flex-column padding beats layered tw:p-0/tw:pr-0 -->
            <div class="flex-column tw:p-0" style="padding: 0;">

              <div class="flex-row tw:h-full tw:justify-center tw:items-end">

                <div class="flex-column">
                  <button class="btn btn-outline-primary"
                    [ngClass]="{'active': selectedFilterDateRange == '7days'}" type="button"
                  (click)="filterDateRangeChange('7days')">Last 7 Days</button>
                </div>

                <div class="flex-column">
                  <button class="btn btn-outline-primary"
                    [ngClass]="{'active': selectedFilterDateRange == '30days'}" type="button"
                  (click)="filterDateRangeChange('30days')">Last 30 Days</button>
                </div>

                <div class="flex-column">
                  <button class="btn btn-outline-primary"
                    [ngClass]="{'active': selectedFilterDateRange == '60days'}" type="button"
                  (click)="filterDateRangeChange('60days')">Last 60 Days</button>
                </div>

                <div class="flex-column tw:pr-0" style="padding-right: 0;">
                  <button class="btn btn-outline-primary"
                    [ngClass]="{'active': selectedFilterDateRange == 'custom'}" type="button"
                  (click)="filterDateRangeChange('custom')">Custom</button>
                </div>

              </div>

              @if (selectedFilterDateRange == 'custom') {
                <div class="flex-row">
                  <div class="flex-column">
                    <label class="overview-filter-label">From Date</label>
                    <input type="date" class="field__control" [(ngModel)]="fromDate" [ngModelOptions]="{standalone: true}" (change)="validateDates()">
                      @if (fromDateAfterToDate) {
                        <span class="field__error">From date cannot be after To date</span>
                      }
                    </div>
                    <div class="flex-column tw:pr-0" style="padding-right: 0;">
                      <label class="overview-filter-label">To Date</label>
                      <input type="date" class="field__control" [(ngModel)]="toDate" [ngModelOptions]="{standalone: true}" (change)="validateDates()">
                      </div>
                    </div>
                  }

                </div>

              </div>

              <div class="tw:flex tw:lg:hidden tw:flex-row tw:flex-wrap tw:w-full tw:justify-between">

                <div class="flex-column">
                  <button class="btn btn-outline-primary"
                    [ngClass]="{'active': selectedFilterDateRange == '7days'}" type="button"
                  (click)="filterDateRangeChange('7days')">Last 7 Days</button>
                </div>

                <div class="flex-column">
                  <button class="btn btn-outline-primary"
                    [ngClass]="{'active': selectedFilterDateRange == '30days'}" type="button"
                  (click)="filterDateRangeChange('30days')">Last 30 Days</button>
                </div>

                <div class="flex-column">
                  <button class="btn btn-outline-primary"
                    [ngClass]="{'active': selectedFilterDateRange == '90days'}" type="button"
                  (click)="filterDateRangeChange('90days')">Last 90 Days</button>
                </div>

              </div>

              <div class="tw:flex tw:lg:hidden tw:flex-row tw:flex-wrap tw:w-full tw:justify-between">

                <div class="flex-column tw:self-end tw:mb-1 tw:pb-4">
                  <button class="btn btn-outline-primary"
                    [ngClass]="{'active': selectedFilterDateRange == 'custom'}" type="button"
                  (click)="filterDateRangeChange('custom')">Custom</button>
                </div>

                @if (selectedFilterDateRange == 'custom') {
                  <div class="flex-column">
                    <label class="overview-filter-label">From Date</label>
                    <input type="date" class="field__control" [(ngModel)]="fromDate" [ngModelOptions]="{standalone: true}" (change)="validateDates()">
                      @if (fromDateAfterToDate) {
                        <span class="field__error">From date cannot be after To date</span>
                      }
                    </div>
                  }

                  @if (selectedFilterDateRange == 'custom') {
                    <div class="flex-column">
                      <label class="overview-filter-label">To Date</label>
                      <input type="date" class="field__control" [(ngModel)]="toDate" [ngModelOptions]="{standalone: true}" (change)="validateDates()">
                      </div>
                    }

                  </div>
          } @else {
            <div class="filter-bar__actions">
              <div class="filter-bar__presets" role="group" aria-label="Date range">
                <button class="btn btn-outline-primary btn-sm" [ngClass]="{'active': selectedFilterDateRange == '7days'}" type="button"
                  (click)="filterDateRangeChange('7days')">Last 7 Days</button>
                <button class="btn btn-outline-primary btn-sm" [ngClass]="{'active': selectedFilterDateRange == '30days'}" type="button"
                  (click)="filterDateRangeChange('30days')">Last 30 Days</button>
                <!-- 60 days at lg and up, 90 below it: the same choices each width offered before. -->
                <span class="tw:hidden tw:lg:flex">
                  <button class="btn btn-outline-primary btn-sm" [ngClass]="{'active': selectedFilterDateRange == '60days'}" type="button"
                    (click)="filterDateRangeChange('60days')">Last 60 Days</button>
                </span>
                <span class="tw:flex tw:lg:hidden">
                  <button class="btn btn-outline-primary btn-sm" [ngClass]="{'active': selectedFilterDateRange == '90days'}" type="button"
                    (click)="filterDateRangeChange('90days')">Last 90 Days</button>
                </span>
                <button class="btn btn-outline-primary btn-sm" [ngClass]="{'active': selectedFilterDateRange == 'custom'}" type="button"
                  (click)="filterDateRangeChange('custom')">Custom</button>
              </div>
              <div class="filter-bar__buttons">
                <app-filter-clear-all (clear)="clearAll()"></app-filter-clear-all>
                <button type="button" class="btn btn-primary" (click)="getFeedbackData()" [disabled]="fromDateAfterToDate">Search</button>
              </div>
            </div>
          }

                </div>

                @if (!filtersEnabled) {
                <div class="mobile-grid">

                  <div class="flex-row tw:my-4">
                    <div class="flex-column">
                      <label class="field__label">Client</label>
                      <app-searchable-select class="tw:w-full" [(ngModel)]="selectedClient" (ngModelChange)="onClientChanged($event)" [items]="clientList"
                        displayField="dropdownDisplay" [disabledPredicate]="clientDisabled"
                        placeholder="--- Select Client ---" searchPlaceholder="Search clients…"></app-searchable-select>
                    </div>
                  </div>

                  <ng-container *appFeatureSwitch="filtersKey">
                    <div class="flex-row">
                      <div class="flex-column">
                        <app-brand-filter [(companyIds)]="companyIds"></app-brand-filter>
                      </div>
                    </div>

                    <div class="flex-row" data-filter="survey-type">
                      <div class="flex-column">
                        <label class="field__label">Survey type</label>
                        <select class="field__control" [(ngModel)]="surveyType">
                          <option value="">Any</option>
                          <option value="SESSION">Session</option>
                          <option value="TUITION">Tuition</option>
                        </select>
                      </div>
                    </div>

                    <div class="flex-row" data-filter="tutor">
                      <div class="flex-column">
                        <label class="field__label">Tutor</label>
                        <app-searchable-select class="tw:w-full" [(ngModel)]="tutorId" [items]="tutorList"
                          displayField="name" valueField="id" [disabled]="searchAllClients || !selectedClient"
                          placeholder="All tutors" searchPlaceholder="Search tutors…"></app-searchable-select>
                      </div>
                    </div>
                  </ng-container>

                  <div class="flex-row tw:mt-2 tw:py-2 tw:md:mt-6 tw:md:pt-6">
                    <div class="flex-column tw:pt-2" style="max-width: 590px;">
                      <label class="field__toggle"><input type="checkbox" [(ngModel)]="searchAllClients" /><span class="field__toggle-track"></span> Search All Clients</label>
                    </div>
                  </div>

                  <div class="flex-row">

                    <div class="flex-column">
                      <button class="btn btn-outline-primary"
                        [ngClass]="{'active': selectedFilterDateRange == '7days'}" type="button"
                      (click)="filterDateRangeChange('7days')">Last 7 Days</button>
                    </div>

                    <div class="flex-column">
                      <button class="btn btn-outline-primary"
                        [ngClass]="{'active': selectedFilterDateRange == '30days'}" type="button"
                      (click)="filterDateRangeChange('30days')">Last 30 Days</button>
                    </div>
                  </div>

                  <div class="flex-row">
                    <div class="flex-column">
                      <button class="btn btn-outline-primary"
                        [ngClass]="{'active': selectedFilterDateRange == '90days'}" type="button"
                      (click)="filterDateRangeChange('90days')">Last 90 Days</button>
                    </div>

                    <div class="flex-column">
                      <button class="btn btn-outline-primary"
                        [ngClass]="{'active': selectedFilterDateRange == 'custom'}" type="button"
                      (click)="filterDateRangeChange('custom')">Custom</button>
                    </div>
                  </div>

                  @if (selectedFilterDateRange == 'custom') {
                    <div class="flex-row tw:my-4">
                      <div class="flex-column">
                        <label>From Date</label>
                        <input type="date" class="field__control" [(ngModel)]="fromDate" [ngModelOptions]="{standalone: true}" (change)="validateDates()">
                          @if (fromDateAfterToDate) {
                            <span class="field__error">From date cannot be after To date</span>
                          }
                        </div>
                      </div>
                    }

                    @if (selectedFilterDateRange == 'custom') {
                      <div class="flex-row tw:my-4">
                        <div class="flex-column">
                          <label>To Date</label>
                          <input type="date" class="field__control" [(ngModel)]="toDate" [ngModelOptions]="{standalone: true}" (change)="validateDates()">
                          </div>
                        </div>
                      }

                      <div class="flex-row tw:my-6 tw:pt-4">
                        <div class="flex-column">
                          <button type="submit" class="btn-primary btn tw:mx-1 tw:w-full" (click)="getFeedbackData()"
                          style="height: 35px;">Search</button>
                          <app-filter-clear-all *appFeatureSwitch="filtersKey" (clear)="clearAll()"></app-filter-clear-all>
                        </div>
                      </div>

                    </div>
                }

                  </div>

                </ng-template>

                @for (feedbackSurvey of feedbackSurveys; track feedbackSurvey) {
                  <div class="tw:px-1 tw:w-full"
                    [ngClass]="{'tw:sm:w-1/2 tw:md:w-1/3': !feedbackSurvey.showDashboardTimeSeries}" [hidden]="refreshingGraph">
                    <div class="dashboard-item-container tw:m-2">
                      <dashboard-main-item-section [feedbackDashboardItem]="feedbackSurvey"></dashboard-main-item-section>
                    </div>
                  </div>
                }

              </div>
            </div>